module.exports = __webpack_public_path__ + "media/images/meta/rumble_aus/favicon-931ffcffed328ceed7b4ec84eacc4537.png";